import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqContaTipo = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/conta-tipo", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/conta-tipo/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/conta-tipo", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listAll: async function () {
		return apiServer
			.get(`portal/v1/conta-tipo/all`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqContaTipo;
